'use client'

import { useEffect, useState } from 'react'

/**
 * Syncs a value to localStorage. Returns [value, setValue] tuple.
 */
export function useLocalStorage<T>(
  key: string,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return defaultValue
    try {
      const stored = localStorage.getItem(key)
      if (stored === null || stored === 'undefined') return defaultValue
      return JSON.parse(stored) as T
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // noop — storage might be full or unavailable
    }
  }, [key, value])

  return [value, setValue]
}
